import React, { useEffect, useState } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import SlickSlider from "react-slick";
// @ts-ignore
import { Slider } from "react-burgers";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import logo from "./images/avaya-onecloud-top-logo.svg";
import mobileLogo from "./images/avaya-mobile-logo.svg";
import footerLogo from "./images/avaya-footer-logo.svg";
import "./Layout.scss";
import { t } from "i18next";

export const TAB_LOOKUP = {
  INTRODUCTION: 0,
  CHALLENGES: 1,
  CAPABILITIES: 2,
  PARTNER_ECOSYSTEM: 3,
  // AWARDS: 5,
  CONCLUSION: 4,
};

export const CAPABILITIES_LOOKUP = {
  BIOMETRICS: 0,
  CONVERSATIONAL_AI: 1,
  VIRTUAL_COWORKERS: 2,
  INTELLIGENT_ROUTING: 3,
  AGENT_WELLNESS: 4,
  REAL_TIME_EMPLOYEE_GUIDANCE: 5,
  ORCHESTRATING_WORKFLOWS: 6,
  PROACTIVE_OUTREACH: 7,
  AI_NOISE_REMOVAL: 8,
  COLLABORATION: 9,
  INSIGHTS_ANALYTICS: 10,
};

function Layout({
  activeTab = 0,
  capabilitiesTab = null,
  children,
}: {
  activeTab?: number;
  capabilitiesTab?: null | number;
  children: any;
}) {
  const sliderRef = React.useRef<Slider | null>(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  switch (pathname) {
    case "/":
      activeTab = TAB_LOOKUP.INTRODUCTION;
      break;
    case "/challenges":
      activeTab = TAB_LOOKUP.CHALLENGES;
      break;
    case "/capabilities":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      break;
    case "/capabilities-ai":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      break;

    case "/capabilities-biometrics":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.BIOMETRICS;
      break;

    case "/capabilities-conversational-ai":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.CONVERSATIONAL_AI;
      break;

    case "/capabilities-virtual-coworkers":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.VIRTUAL_COWORKERS;
      break;

    case "/capabilities-intelligent-routing":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.INTELLIGENT_ROUTING;
      break;

    case "/capabilities-agent-wellness":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.AGENT_WELLNESS;
      break;

    case "/capabilities-real-time-employee-guidance":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.REAL_TIME_EMPLOYEE_GUIDANCE;
      break;

    case "/capabilities-orchestrating-workflows":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.ORCHESTRATING_WORKFLOWS;
      break;

    case "/capabilities-outreach":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.PROACTIVE_OUTREACH;
      break;

    case "/capabilities-ai-noise-removal":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.AI_NOISE_REMOVAL;
      break;

    case "/capabilities-collaboration":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.COLLABORATION;
      break;

    case "/capabilities-insights-analytics":
      activeTab = TAB_LOOKUP.CAPABILITIES;
      capabilitiesTab = CAPABILITIES_LOOKUP.INSIGHTS_ANALYTICS;
      break;

    case "/partner-ecosystem":
      activeTab = TAB_LOOKUP.PARTNER_ECOSYSTEM;
      break;

    // case "/awards":
    //   activeTab = TAB_LOOKUP.AWARDS;
    //   break;

    case "/conclusion":
      activeTab = TAB_LOOKUP.CONCLUSION;
      break;
    default:
      activeTab = 0;
      capabilitiesTab = null;
      break;
  }

  let tabStatus = [];
  for (let i = 0; i <= 6; i++) {
    tabStatus[i] =
      activeTab === i
        ? "navbar-active-tab"
        : activeTab > i
        ? "navbar-bold-tab"
        : "navbar-inactive-tab";
  }
  let capabilitiesStatus = [];
  for (let i = 0; i <= 10; i++) {
    capabilitiesStatus[i] =
      capabilitiesTab === i
        ? "capabilities-active-tab"
        : "capabilities-inactive-tab";
  }

  const SampleNextArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: currentSlide < 3 ? "block" : "none",
        }}
        onClick={onClick}
      />
    );
  };

  const SamplePrevArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: currentSlide === 0 ? "none" : "block",
        }}
        onClick={onClick}
      />
    );
  };

  const settings = {
    // dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 6,
    activeSlide: 0,
    afterChange: (index: number) => {
      console.log("afterChange: index", index);
      setCurrentSlide(index);
    },
    beforeChange: (current: number, next: number) => {
      console.log("beforeChange: current", current);
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1050, // make sure this matches the menu break point
        settings: {
          className: "center",
          centerMode: true,
          // infinite: true,
          centerPadding: "60px",
          slidesToShow: 1,
          // speed: 500
        },
      },
    ],
  };

  useEffect(() => {
    if (menuOpen) setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (capabilitiesTab !== null && sliderRef !== null) {
      const destination =
        capabilitiesTab <= CAPABILITIES_LOOKUP.REAL_TIME_EMPLOYEE_GUIDANCE
          ? CAPABILITIES_LOOKUP.BIOMETRICS
          : CAPABILITIES_LOOKUP.PROACTIVE_OUTREACH;
      setSlideIndex(destination);
      // @ts-ignore
      sliderRef.current.slickGoTo(capabilitiesTab);
    }
    if (menuOpen) setMenuOpen(false);
  }, [capabilitiesTab, sliderRef]);

  return (
    <div className={`main-container ${pathname.split("/").pop()}`}>
      <div className="navbar-container-mobile">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <a href="https://www.avaya.com">
            <img src={mobileLogo} style={{ marginTop: 18 }} alt="avaya logo" />
          </a>
          <div className="flex" />
          <Slider
            width={30}
            active={menuOpen}
            onClick={() => {
              setMenuOpen(!menuOpen);
            }}
          />
        </div>
      </div>
      <div className="navbar-container">
        <div className={`container ${menuOpen ? "open" : ""}`}>
          <a href="https://www.avaya.com">
            <img src={logo} alt="avaya logo" />
          </a>
          <div className={`navbar-item ${tabStatus[TAB_LOOKUP.INTRODUCTION]}`}>
            <Link to="/">{t("Introduction.title")}</Link>
          </div>
          <div className={`navbar-item ${tabStatus[TAB_LOOKUP.CHALLENGES]}`}>
            <Link to="/challenges">{t("Challenges.Challenges")}</Link>
          </div>
          <div className={`navbar-item ${tabStatus[TAB_LOOKUP.CAPABILITIES]}`}>
            <Link to="/capabilities">{t("Capabilities")}</Link>
          </div>
          <div
            className={`navbar-item ${tabStatus[TAB_LOOKUP.PARTNER_ECOSYSTEM]}`}
          >
            <Link to="/partner-ecosystem">{t("Partner Ecosystem")}</Link>
          </div>
          <div className={`navbar-item ${tabStatus[TAB_LOOKUP.CONCLUSION]}`}>
            <Link to="/conclusion">{t("Conclusion")}</Link>
          </div>
          <div className={`navbar-item award`}>
            <a
              href="https://www.avaya.com/static/avaya/galore-awards/index.html"
              style={{ color: activeTab === 5 ? "#000000" : "#707070" }}
            >
              {t("Awards")}
            </a>
          </div>
          <div className={`navbar-item contact-us`}>
            <a href="https://www.avaya.com/en/contacts/">{t("Contact Us")}</a>
          </div>
        </div>
      </div>

      <div style={{ position: "relative" }}>
        <div
          className={`capabilities-background ${
            capabilitiesTab !== null && "open"
          }`}
        >
          <SlickSlider ref={sliderRef} {...settings}>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[CAPABILITIES_LOOKUP.BIOMETRICS]
                }`}
              >
                <Link to="/capabilities-biometrics">{t("Biometrics")}</Link>
              </div>
            </div>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[CAPABILITIES_LOOKUP.CONVERSATIONAL_AI]
                }`}
              >
                <Link to="/capabilities-conversational-ai">
                  {t("Conversational AI").replace(/ /g, "\u00a0")}
                </Link>
              </div>
            </div>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[CAPABILITIES_LOOKUP.VIRTUAL_COWORKERS]
                }`}
              >
                <Link to="/capabilities-virtual-coworkers">
                  {t("Virtual Agents").replace(/ /g, "\u00a0")}
                </Link>
              </div>
            </div>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[CAPABILITIES_LOOKUP.INTELLIGENT_ROUTING]
                }`}
              >
                <Link to="/capabilities-intelligent-routing">
                  {t("Intelligent Routing").replace(/ /g, "\u00a0")}
                </Link>
              </div>
            </div>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[CAPABILITIES_LOOKUP.AGENT_WELLNESS]
                }`}
              >
                <Link to="/capabilities-agent-wellness">
                  {t("Agent Wellness").replace(/ /g, "\u00a0")}
                </Link>
              </div>
            </div>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[
                    CAPABILITIES_LOOKUP.REAL_TIME_EMPLOYEE_GUIDANCE
                  ]
                }`}
              >
                <Link to="/capabilities-real-time-employee-guidance">
                  {t("Real Time").replace(/ /g, "\u00a0")}
                  <br />
                  {t("Employee Guidance").replace(/ /g, "\u00a0")}
                </Link>
              </div>
            </div>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[
                    CAPABILITIES_LOOKUP.ORCHESTRATING_WORKFLOWS
                  ]
                }`}
              >
                <Link to="/capabilities-orchestrating-workflows">
                  {t("Orchestrating")}
                  <br />
                  {t("Workflows")}
                </Link>
              </div>
            </div>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[CAPABILITIES_LOOKUP.PROACTIVE_OUTREACH]
                }`}
              >
                <Link to="/capabilities-outreach">{t("Outreach")}</Link>
              </div>
            </div>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[CAPABILITIES_LOOKUP.AI_NOISE_REMOVAL]
                }`}
              >
                <Link to="/capabilities-ai-noise-removal">
                  {t("Capability8_5.title")}
                </Link>
              </div>
            </div>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[CAPABILITIES_LOOKUP.COLLABORATION]
                }`}
              >
                <Link to="/capabilities-collaboration">
                  {t("Collaboration")}
                </Link>
              </div>
            </div>
            <div>
              <div
                className={`capabilities-item ${
                  capabilitiesStatus[CAPABILITIES_LOOKUP.INSIGHTS_ANALYTICS]
                }`}
              >
                <Link to="/capabilities-insights-analytics">
                  {t("Insights Analytics").replace(/ /g, "\u00a0")}
                </Link>
              </div>
            </div>
          </SlickSlider>
        </div>
      </div>
      <div className="content">{children}</div>
      <div className="footer">
        <div className="container">
          <img src={footerLogo} alt="avaya logo" />
          <div style={{ flex: 1 }}></div>
          <div>© 2021 Avaya Inc.</div>
        </div>
      </div>
    </div>
  );
}

export default Layout;
